<div class="cases-table-scroll">
  <table
    mat-table
    class="cases-table mat-elevation-z1"
    data-testid="cases-table"
    multiTemplateDataRows
    matSort
    [dataSource]="dataSource()"
    (matSortChange)="onSortChange($event)"
  >
    @for (column of additionalColumns(); track column.columnDef) {
      <ng-container [matColumnDef]="column.columnDef">
        @if (column.sortable) {
          <th
            *matHeaderCellDef
            mat-header-cell
            [mat-sort-header]="column.sortable"
          >
            <div class="flex hcenter">
              {{ column.header | async }}
            </div>
          </th>
        } @else {
          <th
            *matHeaderCellDef
            mat-header-cell
          >
            <div class="flex hcenter">
              {{ column.header | async }}
            </div>
          </th>
        }
        <td
          *matCellDef="let element"
          mat-cell
        >
          <div class="flex hcenter">
            <ng-container
              [ngComponentOutlet]="column.cell"
              [ngComponentOutletInputs]="{ element }"
            ></ng-container>
          </div>
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="payee_case_reference_id">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        {{ "CASES_TABLE.HEADERS.CASE_ID" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <div
          class="case-id-box"
          (click)="copyCaseIdToClipboard(element.payee_case_reference_id, $event, element)"
        >
          <span
            class="case-id-text"
            data-testid="case-id"
          >
            {{ element.payee_case_reference_id }}
          </span>
          <payee-icon
            name="copy-blue"
            width="14px"
            height="14px"
            class="case-id-icon"
          ></payee-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="id_multi">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <div class="mobile-case-header">
          <div
            class="case-id-box"
            (click)="copyCaseIdToClipboard(element.payee_case_reference_id, $event, element)"
          >
            <span class="case-id-text">
              {{ element.payee_case_reference_id }}
            </span>
          </div>
          <div class="mobile-status-row">
            <ng-container *ngTemplateOutlet="caseStatusBox; context: { element: element }"></ng-container>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="started_at">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        {{ "CASES_TABLE.HEADERS.STARTED_AT" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.started_at | date: "yyyy.MM.dd." }}
      </td>
    </ng-container>

    <ng-container matColumnDef="parties">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        {{ "CASES_TABLE.HEADERS.PARTIES" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        @if (getDebtorTooltip(element)) {
          <strong
            class="debtor-name-with-tooltip"
            matTooltipPosition="below"
            matTooltipClass="debtor-tooltip"
            matTooltipShowDelay="0"
            matTooltipTouchGestures="on"
            [matTooltip]="getDebtorTooltip(element)"
            (click)="debtorTooltipPressed($event)"
          >
            {{ getDebtorDisplayName(element) }}
          </strong>
        }
        @if (!getDebtorTooltip(element)) {
          <strong>
            {{ getDebtorDisplayName(element) }}
          </strong>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="client">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "CASES_TABLE.HEADERS.CLIENT" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          type="button"
          class="client-name-filter"
          (click)="filterByClient(element, $event)"
        >
          {{ element.parties.client_name }}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "CASES_TABLE.HEADERS.STATE" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <ng-container *ngTemplateOutlet="caseStatusBox; context: { element: element }"></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="jurisdiction">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.jurisdiction | countryFlag }}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        @if (element.partner?.logo_url) {
          <img
            class="partner-logo"
            height="24"
            [src]="element.partner.logo_url"
            [alt]="element.partner.name"
          />
        } @else if (getPartnerLogoName(element.partner?.integration)) {
          <payee-icon
            height="24px"
            [name]="getPartnerLogoName(element.partner?.integration)"
          ></payee-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="debt_multi">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <div class="mobile-case-debt">
          <ng-container *ngTemplateOutlet="claimAmounts; context: { element: element }"></ng-container>
          <ng-container *ngTemplateOutlet="paymentStatus; context: { element: element }"></ng-container>

          <strong class="debtor-name-with-tooltip">
            {{ getDebtorDisplayName(element) }}
          </strong>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="original_claim">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        {{ "CASES_TABLE.HEADERS.ORIGINAL_CLAIMS" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <ng-container *ngTemplateOutlet="claimAmounts; context: { element: element }"></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="payment_status">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "CASES_TABLE.HEADERS.PAYMENT_STATUS" | translate }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <ng-container *ngTemplateOutlet="paymentStatus; context: { element: element }"></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <payee-cases-actions-menu
          [element]="element"
          [allowEdit]="allowEdit"
          [allowDelete]="allowDelete"
          [additionalActions]="additionalActions"
          (menuOpened)="onActionsMenuOpen()"
          (menuClosed)="onActionsMenuClosed()"
        ></payee-cases-actions-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="detailsToggle">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <payee-icon name="arrow-down-grey-no-shaft"></payee-icon>
      </td>
    </ng-container>

    <!-- Expanded Content Column -->
    <ng-container matColumnDef="expandedDetail">
      <td
        *matCellDef="let element"
        mat-cell
        class="expanded-detail-cell"
        [attr.colspan]="displayedColumns().length"
      >
        <div class="expanded-detail-inner alt-theme">
          @if (element === expandedElement()) {
            <div
              class="expanded-detail-content"
              animate.enter="expand-enter"
              animate.leave="expand-leave"
            >
              <div class="expanded-detail-content-inner flex column">
                <div class="expanded-content-container flex grow1">
                  <div class="section-container flex column grow1">
                    <h3 class="section-title">
                      {{ "CASES_TABLE.CASE_DETAILS.EVENTS_LABEL" | translate }}
                      <button
                        payee-icon-button
                        class="download-documents-button"
                        color="white"
                        [matTooltip]="'CASES_TABLE.CASE_ACTIONS.DOWNLOAD_DOCUMENTS' | translate"
                        (click)="openDownloadDocumentsDialog(element)"
                      >
                        <mat-icon>download</mat-icon>
                      </button>
                    </h3>
                    <app-case-events [caseItem]="element"></app-case-events>
                  </div>
                  @if (getDisplayedClaimCurrencyCount(element) > 0) {
                    <div class="section-container flex column grow1">
                      <h3 class="section-title">
                        {{ "CASES_TABLE.CASE_DETAILS.DETAILS_LABEL" | translate }}
                      </h3>
                      <app-case-details [caseId]="element.id"></app-case-details>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="displayedColumns()"
      mat-header-row
      class="main-header cases-table-header"
    ></tr>
    <tr
      *matRowDef="let element; columns: displayedColumns()"
      mat-row
      class="element-row cases-table-row"
      [class.expanded-row]="expandedElement() === element"
      (click)="updateExpandedElement(element)"
    ></tr>
    <tr
      *matRowDef="let row; columns: ['expandedDetail']"
      mat-row
      class="detail-row"
    ></tr>
  </table>

  <ng-template
    #claimAmounts
    let-element="element"
  >
    <div class="claims-sum-amount-box">
      @for (displayed_claim of element.displayed_claim | keyvalue; track displayed_claim.key; let i = $index) {
        @let original_amount = displayed_claim.value.original_amount;
        @let currency = $any(displayed_claim.key);

        @if (i < 2) {
          <div class="currency-amount">
            <span class="current">
              {{ original_amount | currency: currency : "symbol-narrow" : "1.0" : "hu" }}
            </span>
            @if (getHiddenClaimOriginalAmount(element, currency) > 0) {
              <span class="accessory">
                + {{ getHiddenClaimOriginalAmount(element, currency) | currency: currency : "symbol-narrow" : "1.0" : "hu" }}
                {{ "CASES_TABLE.ACCESSORY_CLAIM" | translate }}
              </span>
            }
          </div>
        }
      }
      @if (getDisplayedClaimCurrencyCount(element) > 2) {
        <span class="more-currencies">
          {{ "CASES_TABLE.MORE_CURRENCIES" | translate: { count: getDisplayedClaimCurrencyCount(element) - 2 } }}
        </span>
      }
    </div>
  </ng-template>

  <ng-template
    #paymentStatus
    let-element="element"
  >
    @switch (getPaymentStatus(element)) {
      @case ("partial-and-dispute") {
        <span class="payment-status payment-status--partial">
          {{ "CASES_TABLE.PAYMENT_STATUS.PARTIAL_AND_DISPUTE" | translate }}
        </span>
      }
      @case ("partial-dispute") {
        <span class="payment-status payment-status--partial">
          {{ "CASES_TABLE.PAYMENT_STATUS.PARTIAL_DISPUTE" | translate }}
        </span>
      }
      @case ("full-dispute") {
        <span class="payment-status payment-status--partial">
          {{ "CASES_TABLE.PAYMENT_STATUS.FULL_DISPUTE" | translate }}
        </span>
      }
      @case ("partial") {
        <span class="payment-status payment-status--partial">
          {{ "CASES_TABLE.PAYMENT_STATUS.PARTIAL" | translate }}
        </span>
      }
      @case ("full") {
        <span class="payment-status payment-status--full">
          {{ "CASES_TABLE.PAYMENT_STATUS.FULL" | translate }}
        </span>
      }
      @default {
        <span class="payment-status payment-status--none">-</span>
      }
    }
  </ng-template>

  <ng-template
    #caseStatusBox
    let-element="element"
  >
    <div class="flex column status-box">
      <div class="flex vcenter coface-state-row">
        @if (element.bailiff_contact_url) {
          <a
            class="state-box state-box--linked flex vcenter"
            rel="noopener noreferrer"
            target="_blank"
            matTooltipPosition="below"
            matTooltipShowDelay="0"
            matTooltipClass="status-chip-tooltip"
            [class.state-box--ongoing]="element.state.stage === 'ongoing'"
            [href]="element.bailiff_contact_url"
            [matTooltip]="getStatusChipTooltip(element, 'CASES_TABLE.CASE_ACTIONS.BAILIFF_CONTACT')"
            [style.color]="element.state.state_label_text_color"
            [style.background-color]="element.state.state_label_background_color"
            (click)="$event.stopPropagation()"
          >
            <div
              class="state-marker"
              [pulse-sync]="3500"
              [style.background-color]="element.state.state_label_text_color"
            ></div>
            <span class="state">
              {{ element.state.state_label }}{{ element.expected_transition ? " | " : "" }}
              <ng-container *ngTemplateOutlet="stateDate; context: { element: element }"></ng-container>
            </span>
            <payee-icon
              name="external-link-blue"
              height="12px"
            ></payee-icon>
          </a>
        } @else if (element.awaiting_start_payment) {
          <button
            type="button"
            class="state-box state-box--linked flex vcenter"
            matTooltipPosition="below"
            matTooltipShowDelay="0"
            matTooltipClass="status-chip-tooltip"
            [matTooltip]="getStatusChipTooltip(element, 'CASES_TABLE.START_PAYMENT_CHOICE.TOOLTIP')"
            [style.color]="element.state.state_label_text_color"
            [style.background-color]="element.state.state_label_background_color"
            (click)="openStartPaymentChoice(element, $event)"
          >
            <div
              class="state-marker"
              [style.background-color]="element.state.state_label_text_color"
            ></div>
            <span class="state">
              {{ element.state.state_label }}{{ element.expected_transition ? " | " : "" }}
              <ng-container *ngTemplateOutlet="stateDate; context: { element: element }"></ng-container>
            </span>
            <payee-icon
              name="qvik-blue"
              width="auto"
              height="16px"
            ></payee-icon>
          </button>
        } @else if (element.civil_lawsuit_contact) {
          <button
            type="button"
            class="state-box state-box--linked flex vcenter"
            matTooltipPosition="below"
            matTooltipShowDelay="0"
            matTooltipClass="status-chip-tooltip"
            [class.state-box--ongoing]="element.state.stage === 'ongoing'"
            [matTooltip]="getStatusChipTooltip(element, 'CASES_TABLE.CIVIL_LAWSUIT_DIALOG.LINK_TOOLTIP')"
            [style.color]="element.state.state_label_text_color"
            [style.background-color]="element.state.state_label_background_color"
            (click)="openCivilLawsuitDialog(element, $event)"
          >
            <div
              class="state-marker"
              [pulse-sync]="3500"
              [style.background-color]="element.state.state_label_text_color"
            ></div>
            <span class="state">
              {{ element.state.state_label }}{{ element.expected_transition ? " | " : "" }}
              <ng-container *ngTemplateOutlet="stateDate; context: { element: element }"></ng-container>
            </span>
            <payee-icon
              name="info-grey-outline"
              height="12px"
            ></payee-icon>
          </button>
        } @else if (clickableStateAction(element); as stateAction) {
          <button
            type="button"
            class="state-box state-box--linked flex vcenter"
            matTooltipPosition="below"
            matTooltipShowDelay="0"
            matTooltipClass="status-chip-tooltip"
            [class.state-box--ongoing]="element.state.stage === 'ongoing'"
            [matTooltip]="stateActionTooltip(element)"
            [style.color]="element.state.state_label_text_color"
            [style.background-color]="element.state.state_label_background_color"
            (click)="openStateAction(element, $event)"
          >
            <div
              class="state-marker"
              [pulse-sync]="3500"
              [style.background-color]="element.state.state_label_text_color"
            ></div>
            <span class="state">
              {{ element.state.state_label }}{{ element.expected_transition ? " | " : "" }}
              <ng-container *ngTemplateOutlet="stateDate; context: { element: element }"></ng-container>
            </span>
            @if (stateAction.icon) {
              <payee-icon
                width="12px"
                height="12px"
                [name]="stateAction.icon"
              ></payee-icon>
            }
          </button>
        } @else if (element.is_editable && allowEdit) {
          <button
            type="button"
            class="state-box state-box--linked flex vcenter"
            matTooltipPosition="below"
            matTooltipShowDelay="0"
            matTooltipClass="status-chip-tooltip"
            [matTooltip]="getStatusChipTooltip(element, 'CASES_TABLE.CASE_ACTIONS.EDIT')"
            [style.color]="element.state.state_label_text_color"
            [style.background-color]="element.state.state_label_background_color"
            (click)="editCaseFromChip(element, $event)"
          >
            <div
              class="state-marker"
              [style.background-color]="element.state.state_label_text_color"
            ></div>
            <span class="state">
              {{ element.state.state_label }}{{ element.expected_transition ? " | " : "" }}
              <ng-container *ngTemplateOutlet="stateDate; context: { element: element }"></ng-container>
            </span>
            <payee-icon
              name="pencil"
              width="12px"
              height="12px"
            ></payee-icon>
          </button>
        } @else {
          <div
            class="state-box flex vcenter"
            matTooltipPosition="below"
            matTooltipShowDelay="0"
            matTooltipClass="status-chip-tooltip"
            [class.state-box--ongoing]="element.state.stage === 'ongoing'"
            [matTooltip]="getStatusChipTooltip(element)"
            [matTooltipDisabled]="!element.expected_transition"
            [style.color]="element.state.state_label_text_color"
            [style.background-color]="element.state.state_label_background_color"
          >
            <div
              class="state-marker"
              [pulse-sync]="3500"
              [style.background-color]="element.state.state_label_text_color"
            ></div>
            <span class="state">
              {{ element.state.state_label }}{{ element.expected_transition ? " | " : "" }}
              <ng-container *ngTemplateOutlet="stateDate; context: { element: element }"></ng-container>
            </span>
          </div>
        }
        @if (cofaceCasesService.isCofaceStatusLoading(element.id)) {
          <mat-spinner
            class="coface-state-spinner"
            diameter="18"
          ></mat-spinner>
        }
      </div>
      <span class="stage">
        {{ element.state.stage_label }}
      </span>
    </div>
  </ng-template>

  <ng-template
    #stateDate
    let-element="element"
  >
    @if (element.expected_transition; as expectedTransition) {
      <span class="state-date">
        {{ getExpectedTransitionCountdown(expectedTransition.at, now()) }}
      </span>
    }
  </ng-template>
</div>

<mat-paginator
  class="mat-elevation-z1"
  showFirstLastButtons
  [length]="pagination?.total ?? 0"
  [pageIndex]="(pagination?.currentPage ?? 1) - 1"
  [pageSize]="pagination?.perPage ?? 10"
  [pageSizeOptions]="[5, 10, 25]"
  (page)="page.emit($event)"
></mat-paginator>
